<script setup lang="ts">
import { isVNode } from "vue";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from ".";
import { useToast } from "./use-toast";

const { toasts } = useToast();
</script>

<template>
	<ToastProvider>
		<Toast v-for="toast in toasts" class="tw:mb-1" :key="toast.id" v-bind="toast">
			<div class="tw:grid tw:gap-1">
				<ToastTitle v-if="toast.title">
					{{ toast.title }}
				</ToastTitle>
				<template v-if="toast.description">
					<ToastDescription v-if="isVNode(toast.description)">
						<component :is="toast.description" />
					</ToastDescription>
					<ToastDescription v-else>
						{{ toast.description }}
					</ToastDescription>
				</template>
				<ToastClose />
			</div>
			<component :is="toast.action" />
		</Toast>
		<ToastViewport />
	</ToastProvider>
</template>
